<template>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="width: 100%; position: absolute; top: 0; bottom: 0; overflow-y: auto;">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadListData">
            <van-swipe-cell v-for="(item, index) in list" :key="index" :name="index" style="margin-bottom: 10px;">
                <van-cell :border="false" is-link @click="gotoDetail(item.productId)">
                    <div slot="title" style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width: 260px;">{{item.newsTitle}}</div>
                </van-cell>
                <template slot="right">
                    <van-button square type="danger" @click="selectDelete(item.productId)">删除</van-button>
                </template>
            </van-swipe-cell>
        </van-list>
    </van-pull-refresh>
</template>

<script>

    import Vue from 'vue';
    import { List, Dialog, Toast, SwipeCell, Cell, CellGroup, Button, PullRefresh } from 'vant';

    Vue.use(List).use(Dialog).use(Toast).use(SwipeCell).use(Cell).use(CellGroup).use(Button).use(PullRefresh);

    export default {
        name: "Collection",

        data() {
            return {
                isLoading: false,
                loading: false,
                finished: false,
                list: [],
                pageSize: 10,
                page: 0,
            }
        },
        created(){
            this.onRefresh();
        },
        methods: {
            onRefresh() {
                this.isLoading = true;
                this.page = 0;
                this.list = [];
                this.loadListData()
            },
            loadListData() {
                this.page++
                this.loading = true
                this.$axios.get("/article/own", {params: {page: this.page, pageSize: this.pageSize}}).then(res => {
                    this.loading = false;
                    this.isLoading = false;
                    let datas = res.data.rows;
                    this.list = this.list.concat(datas);
                    if(datas.length < this.pageSize) {
                        this.finished = true;
                    }
                }).catch(err => {
                    this.loading = false
                    this.isLoading = false;
                })
            },
            selectDelete(id) {
                this.$axios.get("/article/collection", {params: { newsId: id, type: '0'}}).then(res => {
                    this.onRefresh();
                })
            },
            gotoDetail(id){
                // this.$router.push({path: '/articleDetail', query: {newsId: id}})
                window.location.href = `${process.env.VUE_APP_SHARE_URL}/articleDetail?newsId=${id}`
            }
        }

    }
</script>

<style scoped>

</style>
